import { IMongoWorkspace } from '../../interfaces/mongo-workspace.interface';

export interface ICollection extends IMongoWorkspace {
    name: string;
}
